import * as CONST from "./actionTypes";

const intialState = {
  templates: [],
  error: null,
};

const TemplatesReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.TEMPLATES_LIST:
      return {
        ...state,
        error: null,
      };
    case CONST.TEMPLATES_LIST_SUCCESS:
      return {
        ...state,
        templates: payload,
        error: null,
      };
    case CONST.TEMPLATES_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> EDIT TEMPLATES >>>>>>>>>>>>>>>*/

    case CONST.EDIT_TEMPLATES:
      return {
        ...state,
        error: null,
      };
    case CONST.EDIT_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: payload,
        error: null,
      };
    case CONST.EDIT_TEMPLATES_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE TEMPLATES >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_TEMPLATES:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: { ...payload },
        error: null,
      };
    case CONST.UPDATE_TEMPLATES_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD TEMPLATES >>>>>>>>>>>>>>>*/

    case CONST.ADD_TEMPLATES:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: { ...payload },
        error: null,
      };
    case CONST.ADD_TEMPLATES_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE TEMPLATES >>>>>>>>>>>>>>>*/

    case CONST.DELETE_TEMPLATES:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: payload,
        error: null,
      };
    case CONST.DELETE_TEMPLATES_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default TemplatesReducer;
